import { Flex } from "@acko-tech/building-blocks.ui.common";
import { EXPANDABLES } from "@widgets/coveragePricingBreakup";
import {
    DropdownContainer,
    IDVHeading,
    IDVSectionHeading,
    Price,
    SectionHeader
} from "@widgets/coveragePricingBreakup/styles";
import ArrowUp from "@public/images/arrow-up.svg";
import ArrowDown from "@public/images/arrow-down.svg";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";
import { DashedDivider } from "@widgets/premiumBreakUp/styles";
import SectionDivider from "@components/SectionDivider";
import {
    PremiunValue,
    PremiumHeading,
    PremiumWrapper,
    PlanPrice,
    TextWrapper
} from "./styles";
import DOMPurify from "isomorphic-dompurify";

const mapStateToProps = function (state: any, ownProps: any) {
    return getWidgetSpecificProps(
        state.configuration?.normalisedConfig,
        ownProps.id
    );
};

const ReviewSelectedPlan = (props) => {
    const {
        actions,
        arrowUpSrc,
        arrowDownSrc,
        is_visible,
        expanded,
        value,
        setExpanded,
        cardTitle,
        description,
        planType,
        premiumData,
        totalPremiumData,
        variantName,
        planPriceText,
        planHeading
    } = props;

    if (!is_visible) {
        return null;
    }

    const isExpanded = expanded === EXPANDABLES.PLAN;
    return (
        <>
            <IDVHeading style={{ marginTop: "16px", marginBottom: "8px" }}>
                {planHeading}
            </IDVHeading>
            <SectionHeader
                onClick={() =>
                    setExpanded((prev) =>
                        prev === EXPANDABLES.PLAN ? false : EXPANDABLES.PLAN
                    )
                }
            >
                <TextWrapper style={{ flexDirection: "column" }}>
                    <Flex>
                        <IDVSectionHeading
                            style={{
                                color: "#040222",
                                display: "flex",
                                position: "relative"
                            }}
                        >
                            <span>{planType} </span>
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    maxWidth: "20px",
                                    maxHeight: "20px",
                                    marginLeft: "4px",
                                    position: "absolute",
                                    right: "-20px"
                                }}
                            >
                                {expanded === EXPANDABLES.PLAN ? (
                                    <ImageContainer imgSrc={arrowUpSrc} width={20} height={20} />
                                ) : (
                                    <ImageContainer
                                        imgSrc={arrowDownSrc}
                                        width={20}
                                        height={20}
                                    />
                                )}
                            </div>
                        </IDVSectionHeading>
                    </Flex>
                    {
                        variantName ? <span
                            style={{
                                fontSize: "12px",
                                color: "#666",
                                fontWeight: "500",
                                marginTop: "6px"
                            }}
                        >
                            {`(${variantName})`}
                        </span> : null
                    }
                </TextWrapper>
                {!isExpanded && value ? <Price>₹{value}</Price> : null}
            </SectionHeader>

            <DropdownContainer expanded={isExpanded}>
                <span
                    style={{ fontSize: "12px", color: "#666" }}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(description)
                    }}
                />
                {premiumData?.length ? (
                    <>
                        <SectionDivider />
                        <PremiumWrapper>
                            {premiumData?.map((premiumValue, index) => {
                                const { key, value, isDiscount } = premiumValue;
                                return (
                                    <Flex justifyContent="space-between">
                                        <PremiumHeading>{key}</PremiumHeading>
                                        <PremiunValue isDiscount={isDiscount}>
                                            {isDiscount ? "- " : ""}₹{value}
                                        </PremiunValue>
                                    </Flex>
                                );
                            })}
                        </PremiumWrapper>
                    </>
                ) : null}
                {totalPremiumData?.length ? (
                    <>
                        <SectionDivider />
                        <PremiumWrapper>
                            {totalPremiumData?.map((premiumValue, index) => {
                                const { key, value } = premiumValue;
                                return (
                                    <Flex justifyContent="space-between">
                                        <PremiumHeading>{key}</PremiumHeading>
                                        <PremiunValue>₹{value}</PremiunValue>
                                    </Flex>
                                );
                            })}
                        </PremiumWrapper>
                    </>
                ) : null}

                <SectionDivider />
                <Flex justifyContent="space-between" mb="8px">
                    <PlanPrice>{planPriceText}</PlanPrice>
                    {value ? <PlanPrice>₹{value}</PlanPrice> : null}
                </Flex>
            </DropdownContainer>
        </>
    );
};

export default connect(mapStateToProps)(ReviewSelectedPlan);
